import { LocalizedLink } from "@/components/LocalizedLink";
import { ArrowLeft, ArrowRight } from "lucide-react";

interface NavItem { slug: string; name: string; }

const ORDER: NavItem[] = [
  { slug: "aria-sculpt", name: "ARIA Sculpt Bathtub" },
  { slug: "aria-monolith", name: "ARIA Monolith Tub" },
  { slug: "aria-diamond", name: "ARIA Diamond Bathtub" },
  { slug: "vena-basin", name: "VENA Counter Basin" },
  { slug: "vena-vanity", name: "VENA Vanity Console" },
];

export const PrevNextBathNav = ({ currentSlug }: { currentSlug: string }) => {
  const idx = ORDER.findIndex((p) => p.slug === currentSlug);
  if (idx === -1) return null;

  const prev = ORDER[(idx - 1 + ORDER.length) % ORDER.length];
  const next = ORDER[(idx + 1) % ORDER.length];

  return (
    <nav aria-label="Bath product navigation" className="border-b border-neutral-200 bg-white py-6">
      <div className="container mx-auto grid grid-cols-2 gap-3 px-6 lg:px-12">
        <LocalizedLink
          to={`/bath-sanitary/${prev.slug}`}
          className="group flex items-center gap-3 border border-neutral-200 bg-white px-4 py-3 transition-all hover:border-amber-500 hover:bg-neutral-50"
          aria-label={`Previous product: ${prev.name}`}
        >
          <ArrowLeft className="h-4 w-4 shrink-0 text-amber-600 transition-transform group-hover:-translate-x-0.5" />
          <div className="min-w-0">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">Previous</p>
            <p className="truncate text-sm font-medium text-neutral-900 group-hover:text-amber-600">{prev.name}</p>
          </div>
        </LocalizedLink>

        <LocalizedLink
          to={`/bath-sanitary/${next.slug}`}
          className="group flex items-center justify-end gap-3 border border-neutral-200 bg-white px-4 py-3 text-right transition-all hover:border-amber-500 hover:bg-neutral-50"
          aria-label={`Next product: ${next.name}`}
        >
          <div className="min-w-0">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">Next</p>
            <p className="truncate text-sm font-medium text-neutral-900 group-hover:text-amber-600">{next.name}</p>
          </div>
          <ArrowRight className="h-4 w-4 shrink-0 text-amber-600 transition-transform group-hover:translate-x-0.5" />
        </LocalizedLink>
      </div>
    </nav>
  );
};

export default PrevNextBathNav;
